import { render, staticRenderFns } from "./SmallWinsCapture.vue?vue&type=template&id=126ae970&scoped=true"
import script from "./SmallWinsCapture.vue?vue&type=script&lang=js"
export * from "./SmallWinsCapture.vue?vue&type=script&lang=js"
import style0 from "./SmallWinsCapture.vue?vue&type=style&index=0&id=126ae970&prod&scoped=true&lang=css"
import style1 from "./SmallWinsCapture.vue?vue&type=style&index=1&id=126ae970&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126ae970",
  null
  
)

export default component.exports